import React from 'react';

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';

import { bool, string, func } from 'prop-types';

export default class GlobalNotificationDialog extends React.Component {
  static propTypes = {
    open: bool,
    message: string,
    title: string,
    onRequestClose: func
  };
  static defaultProps = {
    title: ''
  };

  render() {
    return (
      <Dialog
        open={this.props.open}
        onClose={this.props.onRequestClose}
        fullWidth
      >
        <DialogTitle>
          {this.props.title}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {this.props.message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            key="cancel"
            color="primary"
            onClick={this.props.onRequestClose}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}



// WEBPACK FOOTER //
// ./src/client/shared-components/GlobalNotificationDialog/index.js